import * as React from 'react'
import styled from 'styled-components'
import * as Layout from '../layout'
import * as Button from '../components/Button'
import MetaMaskIcon from '../assets/metamask-fox.svg'
import { Grid } from '@material-ui/core'

type Props = {
    onClickConnect: () => void
}

export const Component = (props: Props) => {
    return (
        <Layout.Main>
            <WhiteBox
                container
                direction="column"
                justify="center"
                alignItems="center"
            >
                <ContainerItems item>
                    <Title>CarefulWrap Tool</Title>
                    <SubTitle>Sign in with your metamask.</SubTitle>
                    <SubTitle>Only mainnet is available.</SubTitle>
                    <ButtonWrapper>
                        <Button.Component
                            onClick={props.onClickConnect}
                            text={'Connect MetaMask'}
                            icon={MetaMaskIcon}
                            color={'gradient'}
                        />
                    </ButtonWrapper>
                </ContainerItems>
            </WhiteBox>
        </Layout.Main>
    )
}

const WhiteBox = styled(Grid)`
    padding: 25px;
    background-color: white;
    border-radius: 30px;
`

const ContainerItems = styled(Grid)``

const Title = styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 20px;
    text-align: center;
`

const SubTitle = styled.div`
    color: ${props => props.theme.palette.text.secondary};
    font-size: 20px;
    margin-bottom: 20px;
    text-align: center;
`

const ButtonWrapper = styled.div`
    text-align: center;
    padding-top: 20px;
`
